import React, { useCallback, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Button } from 'components/Button'
import { TPageProps } from 'models/common.model'
import { Container } from 'components/Container'
import { useStressLevelPoints } from 'hooks/useStressLevelPoints'
import { triggerClickOnCanvas } from 'helpers/triggerClickOnCanvas'
import { Cohort, STRESS_SCORE_TEXT_MAP } from 'root-constants'
import { useLocation } from 'react-router'
import { useNextStep } from 'hooks/useNextStep'
import { useSelector } from 'react-redux'
import { selectCurrentVariantCohort } from 'root-redux/selects/common'
import { StyledThanksForSharing as S } from './ThanksForSharing.styles'
import { EMAIL_PAGES_MAP, QUESTION, STRESS_LEVEL_COLOR_MAP } from './constants'

export const ThanksForSharing: React.FC<TPageProps> = ({ pageId }) => {
  const { t } = useTranslation()
  const { search } = useLocation()
  const stressPoints = useStressLevelPoints()
  const cohort = useSelector(selectCurrentVariantCohort)

  const stressLevel = useMemo(
    () => t(STRESS_SCORE_TEXT_MAP[stressPoints].stressTextKey as any),
    [stressPoints, t],
  )

  const stressLevelColor = useMemo(
    () => STRESS_LEVEL_COLOR_MAP[stressPoints],
    [stressPoints],
  )

  const handleContinue = useNextStep({
    pageId,
    question: QUESTION,
    nextPagePath: `/${EMAIL_PAGES_MAP[cohort || Cohort.VARIANT_ONE]}${search}`,
  })

  const handleNextClick = useCallback(
    (event) => {
      triggerClickOnCanvas(event)
      handleContinue('')
    },
    [handleContinue],
  )

  return (
    <Container>
      <S.Title marginBottom={16}>
        {t('onboarding.thanksForSharing.title')}
      </S.Title>
      <S.Text textColor={stressLevelColor}>
        <Trans
          i18nKey="onboarding.thanksForSharing.description"
          values={{ stressLevel }}
          components={{ break: <p />, highlighted: <strong /> }}
        />
      </S.Text>
      <Button onClick={handleNextClick}>{t('actions.continue')}</Button>
    </Container>
  )
}
